export { default } from './TrophyStar'
